import { render, staticRenderFns } from "./TableCheckbox.vue?vue&type=template&id=5a94a584&"
import script from "./TableCheckbox.vue?vue&type=script&lang=js&"
export * from "./TableCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports